import { cssVar, defineStyleConfig } from '@chakra-ui/react';
import { defineStyle } from '@chakra-ui/styled-system';

const $startColor = cssVar('skeleton-start-color');
const $endColor = cssVar('skeleton-end-color');

const darkGray = defineStyle({
    [$startColor.variable]: 'colors.gray.200',
    [$endColor.variable]: 'colors.gray.300',
});

const skeletonTheme = defineStyleConfig({
    baseStyle: {
        [$startColor.variable]: 'colors.gray.100',
        [$endColor.variable]: '#F3F3F3',
    },
    variants: { darkGray },
});

export default skeletonTheme;
